import { render, staticRenderFns } from "./Conpany.vue?vue&type=template&id=b790c276&scoped=true"
import script from "./Conpany.vue?vue&type=script&lang=js"
export * from "./Conpany.vue?vue&type=script&lang=js"
import style0 from "./Conpany.vue?vue&type=style&index=0&id=b790c276&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b790c276",
  null
  
)

export default component.exports